import { ModelessFormStore } from "src/components/ModelessForm";
import { onError } from "src/common/onError";
import { FormDataStore } from "../model/formData";
import { NodeId } from "../model/node";
import { SelectionStore } from "../model/selection";
import { TreeStore } from "../model/tree";
import { NodeLoading } from "./loading";

/**
 * Выбор узла.
 *
 * Порядок один и тот же: отметить выбор, дождаться данных объекта, убедиться,
 * что выбор не сменился, и только тогда наполнить форму. Пропуск проверяется
 * дважды, потому что между шагами пользователь успевает кликнуть в другое место.
 */
export class NodeSelection {
  constructor(
    private readonly selection: SelectionStore,
    private readonly tree: TreeStore,
    private readonly formData: FormDataStore,
    private readonly loading: NodeLoading,
    private readonly formStore: ModelessFormStore,
  ) {}

  /** Выбор с защитой несохранённых правок. */
  safeSelect(id: NodeId | null) {
    this.formStore.safeAction(() => {
      this.select(id).catch(onError);
    });
  }

  async select(id: NodeId | null, isNewItem?: boolean) {
    const token = this.selection.select(id);
    if (!id) {
      this.formData.clear();
      return;
    }
    // Пока грузятся данные объекта, экран показывает ожидание, а не пустоту
    this.formData.markWaiting(token);
    try {
      await this.loading.ensureObject(id);
    } catch (error) {
      this.formData.fail(error, token);
      return;
    }
    if (!this.selection.isActual(token)) return;
    // Узел ищется заново: пока грузились детали, поддерево могло быть пересобрано
    const node = this.tree.node(id);
    if (!node) {
      this.formData.clear();
      return;
    }
    await this.formData.load(node, token, isNewItem);
  }
}
